import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/task_detail.js';
import { shareColumnsExtend } from './share';
export const filterColumns = {
  title_cont: {
    model_name: 'Task',
    column_type: 'string',
    column_name: 'title',
  },
  assignees_id_eq: {
    model_name: 'User',
    column_type: 'string',
    column_name: 'id',
  },
  creator_id_eq: {
    column_type: 'belongs_to',
    column_name: 'creator',
    extra: {
      model_name: 'User',
      value_column: 'id',
    },
    model_name: 'Task',
  },
  creator: {
    column_type: 'belongs_to',
    column_name: 'creator',
    extra: {
      model_name: 'User',
      value_column: 'id',
    },
    model_name: 'Task',
  },
}
export const formColumnsConfig = {
  'self': {
    'title': { required: true, disabledUpdate: false },
    'content': { required: true, disabledUpdate: false },
    'assignee_ids': { required: true, disabledUpdate: false },
    'filters': { required: false, disabledUpdate: false },
  },
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('Task', columns))
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('Task', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
